import React from "react";

export default function YardimHatlari() {
  return (
    <div>
      <h1> Yardım Hatları</h1>
    </div>
  );
}
